// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
  baseUrl:
    | "https://api-bluvo.com"
    | "https://test.api-bluvo.com"
    | (string & {});
};

export const SchemaEnum = {
  COINBASE: "coinbase",
  KRAKEN: "kraken",
  BINANCE: "binance",
  LOCAL_CEX: "local-cex",
  BINANCE_WEB: "binance-web",
  BYBIT_WEB: "bybit-web",
} as const;

export type SchemaEnum = (typeof SchemaEnum)[keyof typeof SchemaEnum];

export const StatusEnum = {
  LIVE: "live",
  OFFLINE: "offline",
  MAINTENANCE: "maintenance",
  COMING_SOON: "coming_soon",
} as const;

export type StatusEnum = (typeof StatusEnum)[keyof typeof StatusEnum];

export const ExchangeEnum = {
  ACE: "ace",
  ASCENDEX: "ascendex",
  BEQUANT: "bequant",
  BIGONE: "bigone",
  BINANCE: "binance",
  BINANCE_WEB: "binance-web",
  COINBASE: "coinbase",
  BINANCEUS: "binanceus",
  BINGX: "bingx",
  BIT2C: "bit2c",
  BITBANK: "bitbank",
  BITBNS: "bitbns",
  BITCOINCOM: "bitcoincom",
  BITFINEX: "bitfinex",
  BITFLYER: "bitflyer",
  BITGET: "bitget",
  BITHUMB: "bithumb",
  BITMART: "bitmart",
  BITMEX: "bitmex",
  BITOPRO: "bitopro",
  BITPANDA: "bitpanda",
  BITRUE: "bitrue",
  BITSO: "bitso",
  BITSTAMP: "bitstamp",
  BITTEAM: "bitteam",
  BITVAVO: "bitvavo",
  BYBIT: "bybit",
  BYBIT_WEB: "bybit-web",
  BL3P: "bl3p",
  BLOCKCHAINCOM: "blockchaincom",
  BLOFIN: "blofin",
  BTCALPHA: "btcalpha",
  BTCBOX: "btcbox",
  BTCMARKETS: "btcmarkets",
  BTCTURK: "btcturk",
  CEX: "cex",
  COINCHECK: "coincheck",
  COINEX: "coinex",
  COINLIST: "coinlist",
  COINMATE: "coinmate",
  COINMETRO: "coinmetro",
  COINONE: "coinone",
  COINSPH: "coinsph",
  COINSPOT: "coinspot",
  CRYPTOCOM: "cryptocom",
  DELTA: "delta",
  DERIBIT: "deribit",
  DIGIFINEX: "digifinex",
  EXMO: "exmo",
  FMFWIO: "fmfwio",
  GATE: "gate",
  GATEIO: "gateio",
  GEMINI: "gemini",
  HASHKEY: "hashkey",
  HITBTC: "hitbtc",
  HOLLAEX: "hollaex",
  HTX: "htx",
  HUOBI: "huobi",
  HUOBIJP: "huobijp",
  HYPERLIQUID: "hyperliquid",
  INDEPENDENTRESERVE: "independentreserve",
  INDODAX: "indodax",
  KRAKEN: "kraken",
  KRAKENFUTURES: "krakenfutures",
  KUCOIN: "kucoin",
  KUCOINFUTURES: "kucoinfutures",
  LATOKEN: "latoken",
  LBANK: "lbank",
  LUNO: "luno",
  MERCADO: "mercado",
  MEXC: "mexc",
  NDAX: "ndax",
  NOVADAX: "novadax",
  OCEANEX: "oceanex",
  OKCOIN: "okcoin",
  OKX: "okx",
  ONETRADING: "onetrading",
  OXFUN: "oxfun",
  P2B: "p2b",
  PARADEX: "paradex",
  PAYMIUM: "paymium",
  PHEMEX: "phemex",
  POLONIEX: "poloniex",
  POLONIEXFUTURES: "poloniexfutures",
  PROBIT: "probit",
  TIMEX: "timex",
  TRADEOGRE: "tradeogre",
  UPBIT: "upbit",
  VERTEX: "vertex",
  WAVESEXCHANGE: "wavesexchange",
  WHITEBIT: "whitebit",
  WOO: "woo",
  WOOFIPRO: "woofipro",
  XT: "xt",
  YOBIT: "yobit",
  ZAIF: "zaif",
  ZONDA: "zonda",
  LOCAL_CEX: "local-cex",
} as const;

export type ExchangeEnum = (typeof ExchangeEnum)[keyof typeof ExchangeEnum];

export const StatusEnum2 = {
  SUCCESS: "SUCCESS",
  INVALID_API_CREDENTIALS: "INVALID_API_CREDENTIALS",
} as const;

export type StatusEnum2 = (typeof StatusEnum2)[keyof typeof StatusEnum2];

export const TypeEnum = {
  WALLET_NOT_FOUND: "WALLET_NOT_FOUND",
  WALLET_IDENTITY_NOT_FOUND: "WALLET_IDENTITY_NOT_FOUND",
} as const;

export type TypeEnum = (typeof TypeEnum)[keyof typeof TypeEnum];

export const SchemaEnum2 = {
  ACE: "ace",
  ASCENDEX: "ascendex",
  BEQUANT: "bequant",
  BIGONE: "bigone",
  BINANCE: "binance",
  BINANCE_WEB: "binance-web",
  COINBASE: "coinbase",
  BINANCEUS: "binanceus",
  BINGX: "bingx",
  BIT2C: "bit2c",
  BITBANK: "bitbank",
  BITBNS: "bitbns",
  BITCOINCOM: "bitcoincom",
  BITFINEX: "bitfinex",
  BITFLYER: "bitflyer",
  BITGET: "bitget",
  BITHUMB: "bithumb",
  BITMART: "bitmart",
  BITMEX: "bitmex",
  BITOPRO: "bitopro",
  BITPANDA: "bitpanda",
  BITRUE: "bitrue",
  BITSO: "bitso",
  BITSTAMP: "bitstamp",
  BITTEAM: "bitteam",
  BITVAVO: "bitvavo",
  BYBIT: "bybit",
  BYBIT_WEB: "bybit-web",
  BL3P: "bl3p",
  BLOCKCHAINCOM: "blockchaincom",
  BLOFIN: "blofin",
  BTCALPHA: "btcalpha",
  BTCBOX: "btcbox",
  BTCMARKETS: "btcmarkets",
  BTCTURK: "btcturk",
  CEX: "cex",
  COINCHECK: "coincheck",
  COINEX: "coinex",
  COINLIST: "coinlist",
  COINMATE: "coinmate",
  COINMETRO: "coinmetro",
  COINONE: "coinone",
  COINSPH: "coinsph",
  COINSPOT: "coinspot",
  CRYPTOCOM: "cryptocom",
  DELTA: "delta",
  DERIBIT: "deribit",
  DIGIFINEX: "digifinex",
  EXMO: "exmo",
  FMFWIO: "fmfwio",
  GATE: "gate",
  GATEIO: "gateio",
  GEMINI: "gemini",
  HASHKEY: "hashkey",
  HITBTC: "hitbtc",
  HOLLAEX: "hollaex",
  HTX: "htx",
  HUOBI: "huobi",
  HUOBIJP: "huobijp",
  HYPERLIQUID: "hyperliquid",
  INDEPENDENTRESERVE: "independentreserve",
  INDODAX: "indodax",
  KRAKEN: "kraken",
  KRAKENFUTURES: "krakenfutures",
  KUCOIN: "kucoin",
  KUCOINFUTURES: "kucoinfutures",
  LATOKEN: "latoken",
  LBANK: "lbank",
  LUNO: "luno",
  MERCADO: "mercado",
  MEXC: "mexc",
  NDAX: "ndax",
  NOVADAX: "novadax",
  OCEANEX: "oceanex",
  OKCOIN: "okcoin",
  OKX: "okx",
  ONETRADING: "onetrading",
  OXFUN: "oxfun",
  P2B: "p2b",
  PARADEX: "paradex",
  PAYMIUM: "paymium",
  PHEMEX: "phemex",
  POLONIEX: "poloniex",
  POLONIEXFUTURES: "poloniexfutures",
  PROBIT: "probit",
  TIMEX: "timex",
  TRADEOGRE: "tradeogre",
  UPBIT: "upbit",
  VERTEX: "vertex",
  WAVESEXCHANGE: "wavesexchange",
  WHITEBIT: "whitebit",
  WOO: "woo",
  WOOFIPRO: "woofipro",
  XT: "xt",
  YOBIT: "yobit",
  ZAIF: "zaif",
  ZONDA: "zonda",
  LOCAL_CEX: "local-cex",
  NULL: null,
} as const;

export type SchemaEnum2 = (typeof SchemaEnum2)[keyof typeof SchemaEnum2];

export const SchemaEnum3 = {
  TRUE: "true",
  FALSE: "false",
  NULL: null,
} as const;

export type SchemaEnum3 = (typeof SchemaEnum3)[keyof typeof SchemaEnum3];

export const TypeEnum2 = {
  DEPOSIT: "deposit",
  WITHDRAWAL: "withdrawal",
  TRANSACTION: "transaction",
} as const;

export type TypeEnum2 = (typeof TypeEnum2)[keyof typeof TypeEnum2];

export const DirectionEnum = {
  IN: "in",
  OUT: "out",
  NULL: null,
} as const;

export type DirectionEnum = (typeof DirectionEnum)[keyof typeof DirectionEnum];

export const FiatCurrencyEnum = {
  USD: "USD",
  EUR: "EUR",
  NULL: null,
} as const;

export type FiatCurrencyEnum =
  (typeof FiatCurrencyEnum)[keyof typeof FiatCurrencyEnum];

export const StatusEnum3 = {
  PENDING: "pending",
  OK: "ok",
  FAILED: "failed",
  CANCELED: "canceled",
} as const;

export type StatusEnum3 = (typeof StatusEnum3)[keyof typeof StatusEnum3];

export const CategoryEnum = {
  EXCHANGE_WITHDRAWAL_FEE: "exchange_withdrawal_fee",
  NETWORK_FEE: "network_fee",
  PROVIDER_FEE: "provider_fee",
  OTHER: "other",
} as const;

export type CategoryEnum = (typeof CategoryEnum)[keyof typeof CategoryEnum];

export const TypeEnum3 = {
  GENERIC_NOT_FOUND: "GENERIC_NOT_FOUND",
  GENERIC_UNAUTHORIZED: "GENERIC_UNAUTHORIZED",
  GENERIC_INTERNAL_SERVER_ERROR: "GENERIC_INTERNAL_SERVER_ERROR",
  GENERIC_VALIDATION_ERROR: "GENERIC_VALIDATION_ERROR",
  GENERIC_INVALID_REQUEST: "GENERIC_INVALID_REQUEST",
  GENERIC_RATE_LIMIT_EXCEEDED: "GENERIC_RATE_LIMIT_EXCEEDED",
  APIKEY_INSUFFICIENT_PERMISSIONS: "APIKEY_INSUFFICIENT_PERMISSIONS",
  WALLET_NOT_FOUND: "WALLET_NOT_FOUND",
  WALLET_INVALID_CREDENTIALS: "WALLET_INVALID_CREDENTIALS",
  WALLET_IDENTITY_NOT_FOUND: "WALLET_IDENTITY_NOT_FOUND",
  QUOTE_NOT_FOUND: "QUOTE_NOT_FOUND",
  QUOTE_EXPIRED: "QUOTE_EXPIRED",
  WITHDRAWAL_INSUFFICIENT_BALANCE: "WITHDRAWAL_INSUFFICIENT_BALANCE",
  WITHDRAWAL_INSUFFICIENT_BALANCE_FOR_FEE:
    "WITHDRAWAL_INSUFFICIENT_BALANCE_FOR_FEE",
  WITHDRAWAL_INVALID_ADDRESS: "WITHDRAWAL_INVALID_ADDRESS",
  WITHDRAWAL_NETWORK_NOT_SUPPORTED: "WITHDRAWAL_NETWORK_NOT_SUPPORTED",
  WITHDRAWAL_TOO_MANY_ADDRESSES: "WITHDRAWAL_TOO_MANY_ADDRESSES",
  WITHDRAWAL_AMOUNT_BELOW_MINIMUM: "WITHDRAWAL_AMOUNT_BELOW_MINIMUM",
  WITHDRAWAL_AMOUNT_ABOVE_MAXIMUM: "WITHDRAWAL_AMOUNT_ABOVE_MAXIMUM",
  WITHDRAWAL_ASSET_NOT_SUPPORTED: "WITHDRAWAL_ASSET_NOT_SUPPORTED",
  WITHDRAWAL_PROVIDER_ERROR: "WITHDRAWAL_PROVIDER_ERROR",
  WITHDRAWAL_2FA_REQUIRED_TOTP: "WITHDRAWAL_2FA_REQUIRED_TOTP",
  WITHDRAWAL_2FA_REQUIRED_SMS: "WITHDRAWAL_2FA_REQUIRED_SMS",
  WITHDRAWAL_2FA_REQUIRED_FACE_RECOGNITION:
    "WITHDRAWAL_2FA_REQUIRED_FACE_RECOGNITION",
  WITHDRAWAL_2FA_REQUIRED_EMAIL: "WITHDRAWAL_2FA_REQUIRED_EMAIL",
  WITHDRAWAL_2FA_REQUIRED_YUBIKEY: "WITHDRAWAL_2FA_REQUIRED_YUBIKEY",
  WITHDRAWAL_2FA_REQUIRED_PASSPHRASE: "WITHDRAWAL_2FA_REQUIRED_PASSPHRASE",
  WITHDRAWAL_2FA_REQUIRED_MULTI_STEPS: "WITHDRAWAL_2FA_REQUIRED_MULTI_STEPS",
  WITHDRAWAL_2FA_INCOMPLETE: "WITHDRAWAL_2FA_INCOMPLETE",
  WITHDRAWAL_2FA_INVALID: "WITHDRAWAL_2FA_INVALID",
  WITHDRAWAL_2FA_METHOD_NOT_SUPPORTED: "WITHDRAWAL_2FA_METHOD_NOT_SUPPORTED",
  WITHDRAWAL_KYC_REQUIRED: "WITHDRAWAL_KYC_REQUIRED",
  WITHDRAWAL_EMAIL_UNVERIFIED: "WITHDRAWAL_EMAIL_UNVERIFIED",
  WITHDRAWAL_RATE_LIMIT_EXCEEDED: "WITHDRAWAL_RATE_LIMIT_EXCEEDED",
  OAUTH_AUTHORIZATION_FAILED: "OAUTH_AUTHORIZATION_FAILED",
  OAUTH_TOKEN_EXCHANGE_FAILED: "OAUTH_TOKEN_EXCHANGE_FAILED",
  OAUTH_INVALID_STATE: "OAUTH_INVALID_STATE",
  OAUTH_INSUFFICIENT_SCOPE: "OAUTH_INSUFFICIENT_SCOPE",
  OAUTH_QR_CODE_UNAVAILABLE: "OAUTH_QR_CODE_UNAVAILABLE",
  OAUTH_COUNTRY_NOT_DETECTED: "OAUTH_COUNTRY_NOT_DETECTED",
  OAUTH_COUNTRY_NOT_SUPPORTED: "OAUTH_COUNTRY_NOT_SUPPORTED",
  OAUTH_COUNTRY_CODE_INVALID: "OAUTH_COUNTRY_CODE_INVALID",
  WEBHOOK_SIGNATURE_INVALID: "WEBHOOK_SIGNATURE_INVALID",
  WEBHOOK_MISSING_HEADERS: "WEBHOOK_MISSING_HEADERS",
  WEBHOOK_INVALID_TIMESTAMP: "WEBHOOK_INVALID_TIMESTAMP",
  CACHE_MISS: "CACHE_MISS",
  CACHE_EXPIRED: "CACHE_EXPIRED",
  CACHE_INVALID_PATH: "CACHE_INVALID_PATH",
  WITHDRAWAL_DRY_RUN_COMPLETE: "WITHDRAWAL_DRY_RUN_COMPLETE",
  ENRICHMENT_NETWORK_NOT_SUPPORTED: "ENRICHMENT_NETWORK_NOT_SUPPORTED",
  ENRICHMENT_TIMEOUT: "ENRICHMENT_TIMEOUT",
  ENRICHMENT_API_ERROR: "ENRICHMENT_API_ERROR",
} as const;

export type TypeEnum3 = (typeof TypeEnum3)[keyof typeof TypeEnum3];

export const TypeEnum4 = {
  GOOGLE: "GOOGLE",
  EMAIL: "EMAIL",
  FACE: "FACE",
  SMS: "SMS",
  ROAMING_FIDO: "ROAMING_FIDO",
} as const;

export type TypeEnum4 = (typeof TypeEnum4)[keyof typeof TypeEnum4];

export const StatusEnum4 = {
  PENDING: "pending",
  SUCCESS: "success",
  FAILED: "failed",
} as const;

export type StatusEnum4 = (typeof StatusEnum4)[keyof typeof StatusEnum4];

export const RelationEnum = {
  AND: "AND",
  OR: "OR",
} as const;

export type RelationEnum = (typeof RelationEnum)[keyof typeof RelationEnum];

export type Oauth2ExchangeurlgeturlData = {
  body?: never;
  path: {
    /**
     * Exchange identifier.
     */
    exchange: SchemaEnum;
  };
  query: {
    /**
     * Idempotency key.
     */
    idem: string;
    /**
     * Custom base domain for redirect URI i.e. 'example.com'.
     */
    customDomain?: string | null;
  };
  url: "/v0/oauth2/{exchange}/url";
};

export type Oauth2ExchangeurlgeturlResponses = {
  /**
   * Successful response
   */
  200: {
    url: string;
    success: boolean;
    isQRCode?: boolean;
  };
};

export type Oauth2ExchangeurlgeturlResponse =
  Oauth2ExchangeurlgeturlResponses[keyof Oauth2ExchangeurlgeturlResponses];

export type Oauth2ExchangeslistexchangesData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/v0/oauth2/exchanges";
};

export type Oauth2ExchangeslistexchangesResponses = {
  /**
   * Successful response
   */
  200: {
    success: boolean;
    exchanges: Array<{
      id: string;
      name: string;
      logoUrl: string;
      status: StatusEnum;
    }>;
  };
};

export type Oauth2ExchangeslistexchangesResponse =
  Oauth2ExchangeslistexchangesResponses[keyof Oauth2ExchangeslistexchangesResponses];

export type WalletdeleteData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/v0/wallet";
};

export type WalletdeleteErrors = {
  /**
   * Forbidden - Insufficient API key permissions
   */
  403: {
    error: string;
    type: "APIKEY_INSUFFICIENT_PERMISSIONS";
    missing: Array<string>;
  };
  /**
   * Not Found
   */
  404: {
    error: string;
    type: "WALLET_NOT_FOUND";
    result?: unknown;
  };
};

export type WalletdeleteError = WalletdeleteErrors[keyof WalletdeleteErrors];

export type WalletdeleteResponses = {
  /**
   * Successful response
   */
  200: {
    success: boolean;
    message: string;
  };
};

export type WalletdeleteResponse =
  WalletdeleteResponses[keyof WalletdeleteResponses];

export type WalletgetData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/v0/wallet";
};

export type WalletgetErrors = {
  /**
   * Forbidden - Insufficient API key permissions
   */
  403: {
    error: string;
    type: "APIKEY_INSUFFICIENT_PERMISSIONS";
    missing: Array<string>;
  };
  /**
   * Not Found
   */
  404: {
    error: string;
    type: "WALLET_NOT_FOUND";
    result?: unknown;
  };
};

export type WalletgetError = WalletgetErrors[keyof WalletgetErrors];

export type WalletgetResponses = {
  /**
   * Successful response
   */
  200: {
    id: string;
    exchange: ExchangeEnum;
    balances: {
      [key: string]: {
        free?: number | null;
        used?: number | null;
        total?: number | null;
        assetId?: string | null;
        slug?: string | null;
      } | null;
    };
    ipPool?: Array<string> | null;
    invalidApi?: boolean | null;
    createdAt?: string | number | null;
    updatedAt?: string | number | null;
    lastSyncAt?: string | number | null;
    expiresAt?: string | number | null;
  };
};

export type WalletgetResponse = WalletgetResponses[keyof WalletgetResponses];

export type WalletpingpingData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/v0/wallet/ping";
};

export type WalletpingpingErrors = {
  /**
   * Forbidden - Insufficient API key permissions
   */
  403: {
    error: string;
    type: "APIKEY_INSUFFICIENT_PERMISSIONS";
    missing: Array<string>;
  };
  /**
   * Not Found
   */
  404: {
    error: string;
    type: "WALLET_NOT_FOUND";
    result?: unknown;
  };
};

export type WalletpingpingError =
  WalletpingpingErrors[keyof WalletpingpingErrors];

export type WalletpingpingResponses = {
  /**
   * Successful response
   */
  200: {
    id: string;
    exchange: ExchangeEnum;
    status: StatusEnum2;
    success: boolean;
  };
};

export type WalletpingpingResponse =
  WalletpingpingResponses[keyof WalletpingpingResponses];

export type WalletkycgetkycidentityData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/v0/wallet/kyc";
};

export type WalletkycgetkycidentityErrors = {
  /**
   * Forbidden - Insufficient API key permissions
   */
  403: {
    error: string;
    type: "APIKEY_INSUFFICIENT_PERMISSIONS";
    missing: Array<string>;
  };
  /**
   * Not Found
   */
  404: {
    error: string;
    type: TypeEnum;
  };
};

export type WalletkycgetkycidentityError =
  WalletkycgetkycidentityErrors[keyof WalletkycgetkycidentityErrors];

export type WalletkycgetkycidentityResponses = {
  /**
   * Successful response
   */
  200: {
    fullName: string | null;
    email: string | null;
    iban: string | null;
    country: string | null;
  };
};

export type WalletkycgetkycidentityResponse =
  WalletkycgetkycidentityResponses[keyof WalletkycgetkycidentityResponses];

export type WalletlistlistwalletsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Page number (0-indexed).
     */
    page?: number | null;
    /**
     * Number of wallets per page (max 1000).
     */
    limit?: number | null;
    /**
     * Filter by exchange.
     */
    exchange?: SchemaEnum2;
    /**
     * Filter by creation date (from, ISO format).
     */
    createdSince?: string | null;
    /**
     * Filter by creation date (before, ISO format).
     */
    createdBefore?: string | null;
    /**
     * Filter by last sync date (from, ISO format).
     */
    lastSyncSince?: string | null;
    /**
     * Filter by last sync date (before, ISO format).
     */
    lastSyncBefore?: string | null;
    /**
     * Filter by API validity status.
     */
    invalidApi?: SchemaEnum3;
    /**
     * Comma-separated list of fields to include.
     */
    fields?: string | null;
  };
  url: "/v0/wallet/list";
};

export type WalletlistlistwalletsErrors = {
  /**
   * Forbidden - Insufficient API key permissions
   */
  403: {
    error: string;
    type: "APIKEY_INSUFFICIENT_PERMISSIONS";
    missing: Array<string>;
  };
};

export type WalletlistlistwalletsError =
  WalletlistlistwalletsErrors[keyof WalletlistlistwalletsErrors];

export type WalletlistlistwalletsResponses = {
  /**
   * Successful response
   */
  200: {
    wallets: Array<{
      id: string;
      projectId?: string | null;
      createdAt?: string | number | null;
      updatedAt?: string | number | null;
      lastSyncAt?: string | number | null;
      expiresAt?: string | number | null;
      exchange: ExchangeEnum;
      balances: {
        [key: string]: {
          free?: number | null;
          used?: number | null;
          total?: number | null;
          assetId?: string | null;
          slug?: string | null;
        } | null;
      };
      ipPool?: Array<string> | null;
      invalidApi?: boolean | number | null;
    }>;
    pagination: {
      totalCount: number;
      page: number;
      limit: number;
      pageCount: number;
    };
  };
};

export type WalletlistlistwalletsResponse =
  WalletlistlistwalletsResponses[keyof WalletlistlistwalletsResponses];

export type WallettransactionslisttransactionsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Page number (0-indexed).
     */
    page?: number | null;
    /**
     * Number of transactions per page (max 1000).
     */
    limit?: number | null;
    /**
     * Filter transactions after this date (ISO format).
     */
    sinceDate?: string | null;
  };
  url: "/v0/wallet/transactions";
};

export type WallettransactionslisttransactionsErrors = {
  /**
   * Forbidden - Insufficient API key permissions
   */
  403: {
    error: string;
    type: "APIKEY_INSUFFICIENT_PERMISSIONS";
    missing: Array<string>;
  };
};

export type WallettransactionslisttransactionsError =
  WallettransactionslisttransactionsErrors[keyof WallettransactionslisttransactionsErrors];

export type WallettransactionslisttransactionsResponses = {
  /**
   * Successful response
   */
  200: {
    transactions: Array<{
      id: string;
      walletId: string;
      createdAt?: string | number | null;
      updatedAt?: string | number | null;
      timestamp?: string | number | null;
      type: TypeEnum2;
      amount: number;
      currency: string;
      direction?: DirectionEnum;
      feeCost?: number | null;
      feeCurrency?: string | null;
      amountInFiat?: number | null;
      feeInFiat?: number | null;
      fiatCurrency?: FiatCurrencyEnum;
      status: StatusEnum3;
      addressTo?: string | null;
      network?: string | null;
      addressFrom?: string | null;
      hash?: string | null;
      contractAddress?: string | null;
      tag?: string | null;
      exchange?: string | null;
      rawResponse?: unknown;
    }>;
    pagination: {
      totalCount: number;
      page: number;
      limit: number;
      pageCount: number;
      offset: number;
    };
  };
};

export type WallettransactionslisttransactionsResponse =
  WallettransactionslisttransactionsResponses[keyof WallettransactionslisttransactionsResponses];

export type WallettransactiontransactionidgettransactionData = {
  body?: never;
  path: {
    /**
     * The transaction ID
     */
    transactionId: string;
  };
  query?: never;
  url: "/v0/wallet/transaction/{transactionId}";
};

export type WallettransactiontransactionidgettransactionErrors = {
  /**
   * Forbidden - Insufficient API key permissions
   */
  403: {
    error: string;
    type: "APIKEY_INSUFFICIENT_PERMISSIONS";
    missing: Array<string>;
  };
  /**
   * Not Found
   */
  404: {
    error: string;
    type: "GENERIC_NOT_FOUND";
  };
};

export type WallettransactiontransactionidgettransactionError =
  WallettransactiontransactionidgettransactionErrors[keyof WallettransactiontransactionidgettransactionErrors];

export type WallettransactiontransactionidgettransactionResponses = {
  /**
   * Successful response
   */
  200: {
    id: string;
    walletId: string;
    createdAt?: string | number | null;
    updatedAt?: string | number | null;
    timestamp?: string | number | null;
    type: TypeEnum2;
    amount: number;
    currency: string;
    direction?: DirectionEnum;
    feeCost?: number | null;
    feeCurrency?: string | null;
    amountInFiat?: number | null;
    feeInFiat?: number | null;
    fiatCurrency?: FiatCurrencyEnum;
    status: StatusEnum3;
    addressTo?: string | null;
    address?: string | null;
    network?: string | null;
    addressFrom?: string | null;
    hash?: string | null;
    contractAddress?: string | null;
    tag?: string | null;
    exchange?: string | null;
    rawResponse?: unknown;
  };
};

export type WallettransactiontransactionidgettransactionResponse =
  WallettransactiontransactionidgettransactionResponses[keyof WallettransactiontransactionidgettransactionResponses];

export type WalletwithdrawbalancebalanceData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Override balance refresh threshold in minutes. Set to 0 to always refresh balances from the exchange. Defaults to 0.
     */
    refreshThresholdMinutes?: number;
    /**
     * Automatically delete the wallet if API credentials are found to be invalid during balance fetch. Defaults to true.
     */
    autoDeleteIfInvalid?: boolean;
  };
  url: "/v0/wallet/withdraw/balance";
};

export type WalletwithdrawbalancebalanceErrors = {
  /**
   * Forbidden - Insufficient API key permissions
   */
  403: {
    error: string;
    type: "APIKEY_INSUFFICIENT_PERMISSIONS";
    missing: Array<string>;
  };
  /**
   * Not Found
   */
  404: {
    error: string;
    type: "WALLET_NOT_FOUND";
    result?: unknown;
  };
};

export type WalletwithdrawbalancebalanceError =
  WalletwithdrawbalancebalanceErrors[keyof WalletwithdrawbalancebalanceErrors];

export type WalletwithdrawbalancebalanceResponses = {
  /**
   * Successful response
   */
  200: {
    lastSyncAt: string;
    balances: Array<{
      asset: string;
      amount: number;
      amountInFiat?: number | null;
      networks: Array<{
        chainId?:
          | 1
          | 10
          | 14
          | 19
          | 50
          | 56
          | 61
          | 130
          | 137
          | 146
          | 246
          | 295
          | 314
          | 324
          | 480
          | 592
          | 686
          | 747
          | 1100
          | 1116
          | 1284
          | 1285
          | 1329
          | 1514
          | 1776
          | 2020
          | 2088
          | 2222
          | 3338
          | 5464
          | 5888
          | 7000
          | 8453
          | 9745
          | 10001
          | 16600
          | 42161
          | 42170
          | 42220
          | 42262
          | 43114
          | 57073
          | 59144
          | 80094
          | 81457
          | 100009
          | null;
        tokenAddress?: string | null;
        contractAddress?: string | null;
        contractAddressVerified?: boolean | null;
        id: string;
        name: string;
        displayName: string;
        minWithdrawal: string;
        maxWithdrawal?: string;
        assetName: string;
        addressRegex?: string | null;
      }>;
      extra?: {
        slug?: string;
        assetId?: string;
      };
    }>;
  };
};

export type WalletwithdrawbalancebalanceResponse =
  WalletwithdrawbalancebalanceResponses[keyof WalletwithdrawbalancebalanceResponses];

export type WalletwithdrawquotequotationData = {
  body: {
    asset: string;
    amount: string;
    address: string;
    network?: string;
    tag?: string;
    includeFee: boolean;
  };
  path?: never;
  query?: never;
  url: "/v0/wallet/withdraw/quote";
};

export type WalletwithdrawquotequotationErrors = {
  /**
   * Bad Request
   */
  400: {
    error: string;
    type: TypeEnum3;
    result?: unknown;
  };
  /**
   * Forbidden - Insufficient API key permissions
   */
  403: {
    error: string;
    type: "APIKEY_INSUFFICIENT_PERMISSIONS";
    missing: Array<string>;
  };
  /**
   * Not Found
   */
  404: {
    error: string;
    type: "WALLET_NOT_FOUND";
    result?: unknown;
  };
};

export type WalletwithdrawquotequotationError =
  WalletwithdrawquotequotationErrors[keyof WalletwithdrawquotequotationErrors];

export type WalletwithdrawquotequotationResponses = {
  /**
   * Successful response
   */
  200: {
    id: string;
    asset: string;
    amountWithFee?: number | null;
    amountNoFee?: number | null;
    estimatedFee?: number | null;
    amountWithFeeInFiat?: number | null;
    amountNoFeeInFiat?: number | null;
    estimatedFeeInFiat?: number | null;
    destinationAddress: string;
    network?: string | null;
    tag?: string | null;
    estimatedTotal?: number;
    feeDetails?: Array<{
      category: CategoryEnum;
      currency: string;
      amount: number;
      amountInFiat?: number | null;
      fiatCurrency: string;
    }>;
    expiresAt: string;
    additionalInfo: {
      minWithdrawal: string | null;
      maxWithdrawal?: string | null;
    };
  };
};

export type WalletwithdrawquotequotationResponse =
  WalletwithdrawquotequotationResponses[keyof WalletwithdrawquotequotationResponses];

export type WalletwithdrawquoteidexecutewithdrawData = {
  body: {
    twofa?: string | null;
    emailCode?: string | null;
    smsCode?: string | null;
    bizNo?: string | null;
    tag?: string | null;
    params?: {
      dryRun?: boolean;
      [key: string]: unknown | boolean | undefined;
    } | null;
  };
  path: {
    quoteId: string;
  };
  query?: {
    /**
     * Automatically delete the wallet if API credentials are found to be invalid during balance fetch. Defaults to true.
     */
    autoDeleteIfInvalid?: boolean;
  };
  url: "/v0/wallet/withdraw/{quoteId}/execute";
};

export type WalletwithdrawquoteidexecutewithdrawErrors = {
  /**
   * Bad Request
   */
  400: {
    error: string;
    type: TypeEnum3;
    result?:
      | {
          bizNo: string;
          steps: Array<{
            type: TypeEnum4;
            status: StatusEnum4;
            required: boolean;
            metadata?: {
              email?: string;
              emailSent?: boolean;
              qrCodeUrl?: string;
              qrCodeValidSeconds?: number;
              roamingFlowId?: string;
              [key: string]: unknown | string | boolean | number | undefined;
            };
            [key: string]:
              | unknown
              | TypeEnum4
              | StatusEnum4
              | boolean
              | {
                  email?: string;
                  emailSent?: boolean;
                  qrCodeUrl?: string;
                  qrCodeValidSeconds?: number;
                  roamingFlowId?: string;
                  [key: string]:
                    | unknown
                    | string
                    | boolean
                    | number
                    | undefined;
                }
              | undefined;
          }>;
          relation: RelationEnum;
          mfa?: {
            bizNo?: string;
            verified: {
              EMAIL?: boolean;
              SMS?: boolean;
              GOOGLE?: boolean;
              FACE?: boolean;
              ROAMING_FIDO?: boolean;
            };
            attempts?: Array<{
              method: TypeEnum4;
              status: StatusEnum4;
              createdAt: number;
              validatedAt?: number;
              expiresAt?: number;
              success: boolean;
            }>;
            methods?: Array<
              | {
                  method: "EMAIL";
                  email: string;
                }
              | {
                  method: "SMS";
                  phoneNumber: string;
                }
              | {
                  method: "GOOGLE";
                }
              | {
                  method: "FACE";
                  viaMobile: boolean;
                }
              | {
                  method: "ROAMING_FIDO";
                }
            >;
          };
          [key: string]:
            | unknown
            | string
            | Array<{
                type: TypeEnum4;
                status: StatusEnum4;
                required: boolean;
                metadata?: {
                  email?: string;
                  emailSent?: boolean;
                  qrCodeUrl?: string;
                  qrCodeValidSeconds?: number;
                  roamingFlowId?: string;
                  [key: string]:
                    | unknown
                    | string
                    | boolean
                    | number
                    | undefined;
                };
                [key: string]:
                  | unknown
                  | TypeEnum4
                  | StatusEnum4
                  | boolean
                  | {
                      email?: string;
                      emailSent?: boolean;
                      qrCodeUrl?: string;
                      qrCodeValidSeconds?: number;
                      roamingFlowId?: string;
                      [key: string]:
                        | unknown
                        | string
                        | boolean
                        | number
                        | undefined;
                    }
                  | undefined;
              }>
            | RelationEnum
            | {
                bizNo?: string;
                verified: {
                  EMAIL?: boolean;
                  SMS?: boolean;
                  GOOGLE?: boolean;
                  FACE?: boolean;
                  ROAMING_FIDO?: boolean;
                };
                attempts?: Array<{
                  method: TypeEnum4;
                  status: StatusEnum4;
                  createdAt: number;
                  validatedAt?: number;
                  expiresAt?: number;
                  success: boolean;
                }>;
                methods?: Array<
                  | {
                      method: "EMAIL";
                      email: string;
                    }
                  | {
                      method: "SMS";
                      phoneNumber: string;
                    }
                  | {
                      method: "GOOGLE";
                    }
                  | {
                      method: "FACE";
                      viaMobile: boolean;
                    }
                  | {
                      method: "ROAMING_FIDO";
                    }
                >;
              }
            | undefined;
        }
      | {
          bizNo?: string;
          steps?: Array<{
            type: string;
            status: StatusEnum4;
            error?: string;
            [key: string]: unknown | string | StatusEnum4 | undefined;
          }>;
          mfa?: {
            bizNo?: string;
            verified: {
              EMAIL?: boolean;
              SMS?: boolean;
              GOOGLE?: boolean;
              FACE?: boolean;
              ROAMING_FIDO?: boolean;
            };
            attempts?: Array<{
              method: TypeEnum4;
              status: StatusEnum4;
              createdAt: number;
              validatedAt?: number;
              expiresAt?: number;
              success: boolean;
            }>;
            methods?: Array<
              | {
                  method: "EMAIL";
                  email: string;
                }
              | {
                  method: "SMS";
                  phoneNumber: string;
                }
              | {
                  method: "GOOGLE";
                }
              | {
                  method: "FACE";
                  viaMobile: boolean;
                }
              | {
                  method: "ROAMING_FIDO";
                }
            >;
          };
          [key: string]:
            | unknown
            | string
            | Array<{
                type: string;
                status: StatusEnum4;
                error?: string;
                [key: string]: unknown | string | StatusEnum4 | undefined;
              }>
            | {
                bizNo?: string;
                verified: {
                  EMAIL?: boolean;
                  SMS?: boolean;
                  GOOGLE?: boolean;
                  FACE?: boolean;
                  ROAMING_FIDO?: boolean;
                };
                attempts?: Array<{
                  method: TypeEnum4;
                  status: StatusEnum4;
                  createdAt: number;
                  validatedAt?: number;
                  expiresAt?: number;
                  success: boolean;
                }>;
                methods?: Array<
                  | {
                      method: "EMAIL";
                      email: string;
                    }
                  | {
                      method: "SMS";
                      phoneNumber: string;
                    }
                  | {
                      method: "GOOGLE";
                    }
                  | {
                      method: "FACE";
                      viaMobile: boolean;
                    }
                  | {
                      method: "ROAMING_FIDO";
                    }
                >;
              }
            | undefined;
        }
      | {
          valid2FAMethods: Array<string>;
          [key: string]: unknown | Array<string>;
        }
      | {
          bizNo?: string;
          steps?: Array<{
            type: string;
            status: "success";
          }>;
          accountId?: string;
          dryRun: true;
          readyToTransact: true;
          mfa?: {
            bizNo?: string;
            verified: {
              EMAIL?: boolean;
              SMS?: boolean;
              GOOGLE?: boolean;
              FACE?: boolean;
              ROAMING_FIDO?: boolean;
            };
            attempts?: Array<{
              method: TypeEnum4;
              status: StatusEnum4;
              createdAt: number;
              validatedAt?: number;
              expiresAt?: number;
              success: boolean;
            }>;
            methods?: Array<
              | {
                  method: "EMAIL";
                  email: string;
                }
              | {
                  method: "SMS";
                  phoneNumber: string;
                }
              | {
                  method: "GOOGLE";
                }
              | {
                  method: "FACE";
                  viaMobile: boolean;
                }
              | {
                  method: "ROAMING_FIDO";
                }
            >;
          };
          [key: string]:
            | unknown
            | string
            | Array<{
                type: string;
                status: "success";
              }>
            | true
            | {
                bizNo?: string;
                verified: {
                  EMAIL?: boolean;
                  SMS?: boolean;
                  GOOGLE?: boolean;
                  FACE?: boolean;
                  ROAMING_FIDO?: boolean;
                };
                attempts?: Array<{
                  method: TypeEnum4;
                  status: StatusEnum4;
                  createdAt: number;
                  validatedAt?: number;
                  expiresAt?: number;
                  success: boolean;
                }>;
                methods?: Array<
                  | {
                      method: "EMAIL";
                      email: string;
                    }
                  | {
                      method: "SMS";
                      phoneNumber: string;
                    }
                  | {
                      method: "GOOGLE";
                    }
                  | {
                      method: "FACE";
                      viaMobile: boolean;
                    }
                  | {
                      method: "ROAMING_FIDO";
                    }
                >;
              }
            | undefined;
        }
      | {
          [key: string]: unknown;
        };
  };
  /**
   * Forbidden - Insufficient API key permissions
   */
  403: {
    error: string;
    type: "APIKEY_INSUFFICIENT_PERMISSIONS";
    missing: Array<string>;
  };
  /**
   * Not Found
   */
  404: {
    error: string;
    type: TypeEnum3;
    result?:
      | {
          bizNo: string;
          steps: Array<{
            type: TypeEnum4;
            status: StatusEnum4;
            required: boolean;
            metadata?: {
              email?: string;
              emailSent?: boolean;
              qrCodeUrl?: string;
              qrCodeValidSeconds?: number;
              roamingFlowId?: string;
              [key: string]: unknown | string | boolean | number | undefined;
            };
            [key: string]:
              | unknown
              | TypeEnum4
              | StatusEnum4
              | boolean
              | {
                  email?: string;
                  emailSent?: boolean;
                  qrCodeUrl?: string;
                  qrCodeValidSeconds?: number;
                  roamingFlowId?: string;
                  [key: string]:
                    | unknown
                    | string
                    | boolean
                    | number
                    | undefined;
                }
              | undefined;
          }>;
          relation: RelationEnum;
          mfa?: {
            bizNo?: string;
            verified: {
              EMAIL?: boolean;
              SMS?: boolean;
              GOOGLE?: boolean;
              FACE?: boolean;
              ROAMING_FIDO?: boolean;
            };
            attempts?: Array<{
              method: TypeEnum4;
              status: StatusEnum4;
              createdAt: number;
              validatedAt?: number;
              expiresAt?: number;
              success: boolean;
            }>;
            methods?: Array<
              | {
                  method: "EMAIL";
                  email: string;
                }
              | {
                  method: "SMS";
                  phoneNumber: string;
                }
              | {
                  method: "GOOGLE";
                }
              | {
                  method: "FACE";
                  viaMobile: boolean;
                }
              | {
                  method: "ROAMING_FIDO";
                }
            >;
          };
          [key: string]:
            | unknown
            | string
            | Array<{
                type: TypeEnum4;
                status: StatusEnum4;
                required: boolean;
                metadata?: {
                  email?: string;
                  emailSent?: boolean;
                  qrCodeUrl?: string;
                  qrCodeValidSeconds?: number;
                  roamingFlowId?: string;
                  [key: string]:
                    | unknown
                    | string
                    | boolean
                    | number
                    | undefined;
                };
                [key: string]:
                  | unknown
                  | TypeEnum4
                  | StatusEnum4
                  | boolean
                  | {
                      email?: string;
                      emailSent?: boolean;
                      qrCodeUrl?: string;
                      qrCodeValidSeconds?: number;
                      roamingFlowId?: string;
                      [key: string]:
                        | unknown
                        | string
                        | boolean
                        | number
                        | undefined;
                    }
                  | undefined;
              }>
            | RelationEnum
            | {
                bizNo?: string;
                verified: {
                  EMAIL?: boolean;
                  SMS?: boolean;
                  GOOGLE?: boolean;
                  FACE?: boolean;
                  ROAMING_FIDO?: boolean;
                };
                attempts?: Array<{
                  method: TypeEnum4;
                  status: StatusEnum4;
                  createdAt: number;
                  validatedAt?: number;
                  expiresAt?: number;
                  success: boolean;
                }>;
                methods?: Array<
                  | {
                      method: "EMAIL";
                      email: string;
                    }
                  | {
                      method: "SMS";
                      phoneNumber: string;
                    }
                  | {
                      method: "GOOGLE";
                    }
                  | {
                      method: "FACE";
                      viaMobile: boolean;
                    }
                  | {
                      method: "ROAMING_FIDO";
                    }
                >;
              }
            | undefined;
        }
      | {
          bizNo?: string;
          steps?: Array<{
            type: string;
            status: StatusEnum4;
            error?: string;
            [key: string]: unknown | string | StatusEnum4 | undefined;
          }>;
          mfa?: {
            bizNo?: string;
            verified: {
              EMAIL?: boolean;
              SMS?: boolean;
              GOOGLE?: boolean;
              FACE?: boolean;
              ROAMING_FIDO?: boolean;
            };
            attempts?: Array<{
              method: TypeEnum4;
              status: StatusEnum4;
              createdAt: number;
              validatedAt?: number;
              expiresAt?: number;
              success: boolean;
            }>;
            methods?: Array<
              | {
                  method: "EMAIL";
                  email: string;
                }
              | {
                  method: "SMS";
                  phoneNumber: string;
                }
              | {
                  method: "GOOGLE";
                }
              | {
                  method: "FACE";
                  viaMobile: boolean;
                }
              | {
                  method: "ROAMING_FIDO";
                }
            >;
          };
          [key: string]:
            | unknown
            | string
            | Array<{
                type: string;
                status: StatusEnum4;
                error?: string;
                [key: string]: unknown | string | StatusEnum4 | undefined;
              }>
            | {
                bizNo?: string;
                verified: {
                  EMAIL?: boolean;
                  SMS?: boolean;
                  GOOGLE?: boolean;
                  FACE?: boolean;
                  ROAMING_FIDO?: boolean;
                };
                attempts?: Array<{
                  method: TypeEnum4;
                  status: StatusEnum4;
                  createdAt: number;
                  validatedAt?: number;
                  expiresAt?: number;
                  success: boolean;
                }>;
                methods?: Array<
                  | {
                      method: "EMAIL";
                      email: string;
                    }
                  | {
                      method: "SMS";
                      phoneNumber: string;
                    }
                  | {
                      method: "GOOGLE";
                    }
                  | {
                      method: "FACE";
                      viaMobile: boolean;
                    }
                  | {
                      method: "ROAMING_FIDO";
                    }
                >;
              }
            | undefined;
        }
      | {
          valid2FAMethods: Array<string>;
          [key: string]: unknown | Array<string>;
        }
      | {
          bizNo?: string;
          steps?: Array<{
            type: string;
            status: "success";
          }>;
          accountId?: string;
          dryRun: true;
          readyToTransact: true;
          mfa?: {
            bizNo?: string;
            verified: {
              EMAIL?: boolean;
              SMS?: boolean;
              GOOGLE?: boolean;
              FACE?: boolean;
              ROAMING_FIDO?: boolean;
            };
            attempts?: Array<{
              method: TypeEnum4;
              status: StatusEnum4;
              createdAt: number;
              validatedAt?: number;
              expiresAt?: number;
              success: boolean;
            }>;
            methods?: Array<
              | {
                  method: "EMAIL";
                  email: string;
                }
              | {
                  method: "SMS";
                  phoneNumber: string;
                }
              | {
                  method: "GOOGLE";
                }
              | {
                  method: "FACE";
                  viaMobile: boolean;
                }
              | {
                  method: "ROAMING_FIDO";
                }
            >;
          };
          [key: string]:
            | unknown
            | string
            | Array<{
                type: string;
                status: "success";
              }>
            | true
            | {
                bizNo?: string;
                verified: {
                  EMAIL?: boolean;
                  SMS?: boolean;
                  GOOGLE?: boolean;
                  FACE?: boolean;
                  ROAMING_FIDO?: boolean;
                };
                attempts?: Array<{
                  method: TypeEnum4;
                  status: StatusEnum4;
                  createdAt: number;
                  validatedAt?: number;
                  expiresAt?: number;
                  success: boolean;
                }>;
                methods?: Array<
                  | {
                      method: "EMAIL";
                      email: string;
                    }
                  | {
                      method: "SMS";
                      phoneNumber: string;
                    }
                  | {
                      method: "GOOGLE";
                    }
                  | {
                      method: "FACE";
                      viaMobile: boolean;
                    }
                  | {
                      method: "ROAMING_FIDO";
                    }
                >;
              }
            | undefined;
        }
      | {
          [key: string]: unknown;
        };
  };
};

export type WalletwithdrawquoteidexecutewithdrawError =
  WalletwithdrawquoteidexecutewithdrawErrors[keyof WalletwithdrawquoteidexecutewithdrawErrors];

export type WalletwithdrawquoteidexecutewithdrawResponses = {
  /**
   * Successful response
   */
  200: {
    success: boolean;
    error?: string;
    type?: TypeEnum3;
    result?:
      | {
          transactionId: string;
          [key: string]: unknown | string;
        }
      | {
          bizNo: string;
          steps: Array<{
            type: TypeEnum4;
            status: StatusEnum4;
            required: boolean;
            metadata?: {
              email?: string;
              emailSent?: boolean;
              qrCodeUrl?: string;
              qrCodeValidSeconds?: number;
              roamingFlowId?: string;
              [key: string]: unknown | string | boolean | number | undefined;
            };
            [key: string]:
              | unknown
              | TypeEnum4
              | StatusEnum4
              | boolean
              | {
                  email?: string;
                  emailSent?: boolean;
                  qrCodeUrl?: string;
                  qrCodeValidSeconds?: number;
                  roamingFlowId?: string;
                  [key: string]:
                    | unknown
                    | string
                    | boolean
                    | number
                    | undefined;
                }
              | undefined;
          }>;
          relation: RelationEnum;
          mfa?: {
            bizNo?: string;
            verified: {
              EMAIL?: boolean;
              SMS?: boolean;
              GOOGLE?: boolean;
              FACE?: boolean;
              ROAMING_FIDO?: boolean;
            };
            attempts?: Array<{
              method: TypeEnum4;
              status: StatusEnum4;
              createdAt: number;
              validatedAt?: number;
              expiresAt?: number;
              success: boolean;
            }>;
            methods?: Array<
              | {
                  method: "EMAIL";
                  email: string;
                }
              | {
                  method: "SMS";
                  phoneNumber: string;
                }
              | {
                  method: "GOOGLE";
                }
              | {
                  method: "FACE";
                  viaMobile: boolean;
                }
              | {
                  method: "ROAMING_FIDO";
                }
            >;
          };
          [key: string]:
            | unknown
            | string
            | Array<{
                type: TypeEnum4;
                status: StatusEnum4;
                required: boolean;
                metadata?: {
                  email?: string;
                  emailSent?: boolean;
                  qrCodeUrl?: string;
                  qrCodeValidSeconds?: number;
                  roamingFlowId?: string;
                  [key: string]:
                    | unknown
                    | string
                    | boolean
                    | number
                    | undefined;
                };
                [key: string]:
                  | unknown
                  | TypeEnum4
                  | StatusEnum4
                  | boolean
                  | {
                      email?: string;
                      emailSent?: boolean;
                      qrCodeUrl?: string;
                      qrCodeValidSeconds?: number;
                      roamingFlowId?: string;
                      [key: string]:
                        | unknown
                        | string
                        | boolean
                        | number
                        | undefined;
                    }
                  | undefined;
              }>
            | RelationEnum
            | {
                bizNo?: string;
                verified: {
                  EMAIL?: boolean;
                  SMS?: boolean;
                  GOOGLE?: boolean;
                  FACE?: boolean;
                  ROAMING_FIDO?: boolean;
                };
                attempts?: Array<{
                  method: TypeEnum4;
                  status: StatusEnum4;
                  createdAt: number;
                  validatedAt?: number;
                  expiresAt?: number;
                  success: boolean;
                }>;
                methods?: Array<
                  | {
                      method: "EMAIL";
                      email: string;
                    }
                  | {
                      method: "SMS";
                      phoneNumber: string;
                    }
                  | {
                      method: "GOOGLE";
                    }
                  | {
                      method: "FACE";
                      viaMobile: boolean;
                    }
                  | {
                      method: "ROAMING_FIDO";
                    }
                >;
              }
            | undefined;
        }
      | {
          bizNo?: string;
          steps?: Array<{
            type: string;
            status: StatusEnum4;
            error?: string;
            [key: string]: unknown | string | StatusEnum4 | undefined;
          }>;
          mfa?: {
            bizNo?: string;
            verified: {
              EMAIL?: boolean;
              SMS?: boolean;
              GOOGLE?: boolean;
              FACE?: boolean;
              ROAMING_FIDO?: boolean;
            };
            attempts?: Array<{
              method: TypeEnum4;
              status: StatusEnum4;
              createdAt: number;
              validatedAt?: number;
              expiresAt?: number;
              success: boolean;
            }>;
            methods?: Array<
              | {
                  method: "EMAIL";
                  email: string;
                }
              | {
                  method: "SMS";
                  phoneNumber: string;
                }
              | {
                  method: "GOOGLE";
                }
              | {
                  method: "FACE";
                  viaMobile: boolean;
                }
              | {
                  method: "ROAMING_FIDO";
                }
            >;
          };
          [key: string]:
            | unknown
            | string
            | Array<{
                type: string;
                status: StatusEnum4;
                error?: string;
                [key: string]: unknown | string | StatusEnum4 | undefined;
              }>
            | {
                bizNo?: string;
                verified: {
                  EMAIL?: boolean;
                  SMS?: boolean;
                  GOOGLE?: boolean;
                  FACE?: boolean;
                  ROAMING_FIDO?: boolean;
                };
                attempts?: Array<{
                  method: TypeEnum4;
                  status: StatusEnum4;
                  createdAt: number;
                  validatedAt?: number;
                  expiresAt?: number;
                  success: boolean;
                }>;
                methods?: Array<
                  | {
                      method: "EMAIL";
                      email: string;
                    }
                  | {
                      method: "SMS";
                      phoneNumber: string;
                    }
                  | {
                      method: "GOOGLE";
                    }
                  | {
                      method: "FACE";
                      viaMobile: boolean;
                    }
                  | {
                      method: "ROAMING_FIDO";
                    }
                >;
              }
            | undefined;
        }
      | {
          valid2FAMethods: Array<string>;
          [key: string]: unknown | Array<string>;
        }
      | {
          [key: string]: unknown;
        };
  };
};

export type WalletwithdrawquoteidexecutewithdrawResponse =
  WalletwithdrawquoteidexecutewithdrawResponses[keyof WalletwithdrawquoteidexecutewithdrawResponses];

export type OrganizationapikeyapikeyinfoData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/v0/organization/api-key";
};

export type OrganizationapikeyapikeyinfoErrors = {
  /**
   * Forbidden - Insufficient API key permissions
   */
  403: {
    error: string;
    type: "APIKEY_INSUFFICIENT_PERMISSIONS";
    missing: Array<string>;
  };
};

export type OrganizationapikeyapikeyinfoError =
  OrganizationapikeyapikeyinfoErrors[keyof OrganizationapikeyapikeyinfoErrors];

export type OrganizationapikeyapikeyinfoResponses = {
  /**
   * Successful response
   */
  200: {
    permissions?: {
      read?: boolean;
      quote?: boolean;
      withdrawal?: boolean;
      trade?: boolean;
      deposit?: boolean;
      listen?: boolean;
      delete?: boolean;
    } | null;
    rateLimit?: {
      rateLimitEnabled: boolean | null;
      rateLimitTimeWindow: number | null;
      rateLimitMax: number | null;
      requestCount: number | null;
      lastRequest: string | null;
    };
  };
};

export type OrganizationapikeyapikeyinfoResponse =
  OrganizationapikeyapikeyinfoResponses[keyof OrganizationapikeyapikeyinfoResponses];
